// ---------------------------------------------------------------------------
// Prezio Onboard Widget — StepHeading
// ---------------------------------------------------------------------------
// Step title + optional subtitle. Used at the top of every step.
// ---------------------------------------------------------------------------

import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import { useWidgetConfig } from '@/context/WidgetConfigContext';
import styles from './StepHeading.module.css';

interface StepHeadingProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
}

export const StepHeading = forwardRef<HTMLDivElement, StepHeadingProps>(function StepHeading(
  { title, subtitle, icon },
  ref,
) {
  const { showStepSubtitles } = useWidgetConfig();

  return (
    <div className={styles['heading']} ref={ref} tabIndex={-1}>
      <h2 className={styles['title']}>
        {icon && <span className={styles['icon']}>{icon}</span>}
        {title}
      </h2>
      {showStepSubtitles && subtitle && <p className={styles['subtitle']}>{subtitle}</p>}
    </div>
  );
});
